// extracted by mini-css-extract-plugin
module.exports = {"bulkActions":"systemBackupsBulkActions_bulkActions-1tPHo"};